"use client";

import { ReactNode, useEffect } from "react";
import CookieBanner from "../components/ui/CookieBanner";
import { CookieUtils } from "./utils/cookies";

export default function ClientSideInitialization({
  children,
}: {
  children: ReactNode;
}) {
  useEffect(() => {
    // Check if we're in browser context
    if (typeof window !== "undefined") {
      // Set user region in cookies based on timezone
      const detectRegion = () => {
        // This is a simple method - in production, you might want to use a geolocation service
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // European timezones (simplified list)
        const euTimezones = ["Europe/", "Arctic/Longyearbyen"];

        // North American timezones (simplified list)
        const naTimezones = ["America/", "Canada/"];

        if (euTimezones.some((tz) => timezone.startsWith(tz))) {
          CookieUtils.setUserRegion("eu");
          return "eu";
        } else if (naTimezones.some((tz) => timezone.startsWith(tz))) {
          CookieUtils.setUserRegion("na");
          return "na";
        } else {
          CookieUtils.setUserRegion("other");
          return "other";
        }
      };

      detectRegion();

      // Set default user preferences if they don't exist
      if (!CookieUtils.getUserPreferences()) {
        CookieUtils.setUserPreferences({
          theme: "light",
          language: "en",
          notifications: true,
        });
      }
    }
  }, []);

  return (
    <>
      {children}
      <CookieBanner />
    </>
  );
}
